import React from "react";
import "./stylesheets/experience.css";

function Experience() {

    return (
        <>
            <p id="experience-title">Experience</p>

            <div id="experience" className="experience-container">

                <div className="experience-block">
                <div className="title-company">
                    <h2 className="job-title">Desktop Support Specialist</h2>
                    <h3 className="company-name">The University of Texas at Austin</h3>
                </div>
                <p className="experience-details">Mar 2024 - Present · 3 mos | Austin, Texas, United States ·
                    On-site</p>
                <ul>
                    <li>Collaborated in the migration of macOS computers to a central management system, transitioning
                        from an obsolete server to a campus-wide JAMF management server, enhancing system integration
                        and management.
                    </li>
                    <li>Utilized Beyond Trust software and MacOS ScreenSharing to remotely access and troubleshoot user
                        computers, ensuring efficient resolution of technical issues and enhancing user satisfaction and
                        productivity.
                    </li>
                    <li>Managed service requests and reported issues through the ServiceNow ticketing system,
                        prioritizing and resolving tickets effectively.
                    </li>
                </ul>
            </div>

            <div className="experience-block">
                <div className="title-company">
                    <h2 className="job-title">Product Ambassador</h2>
                    <h3 className="company-name">KELLY SERVICES GLOBAL, LLC</h3>
                </div>
                <p className="experience-details">May 2023 - Jan 2024 · 9 mos | Austin, Texas, United States ·
                    Remote</p>
                <ul>
                    <li>Promoted and sold medical-grade massagers to individual customers, consistently meeting or
                        exceeding sales targets.
                    </li>
                    <li>Demonstrated comprehensive product knowledge, effectively explaining features and benefits to
                        potential buyers and addressing their inquiries.
                    </li>
                    <li>Provided exceptional customer service by promptly responding to customer inquiries, resolving
                        issues, and ensuring customer satisfaction throughout the sales process.
                    </li>
                    <li>Built and maintained strong relationships with clients, retailers, and distributors, fostering
                        repeat business and long-term partnerships.
                    </li>
                    <li>Prepared detailed sales reports, analyzing sales data and customer feedback to provide insights
                        for strategic decision-making.
                    </li>
                    <li>Ensured compliance with company policies, industry regulations, and ethical standards in all
                        sales activities, maintaining professionalism and integrity in customer interactions.
                    </li>
                </ul>
            </div>

            <div className="experience-block">
                <div className="title-company">
                    <h2 className="job-title">Platform Experience Analyst</h2>
                    <h3 className="company-name">Accenture</h3>
                </div>
                <p className="experience-details">Sep 2020 - Aug 2022 · 2 yrs | Austin, Texas Metropolitan Area</p>
                <ul>
                    <li>Proficiently handled intellectual property issues, meticulously reviewing infringement reports
                        to identify and address potential violations.
                    </li>
                    <li>Provided valuable input on emerging industry trends, potential escalations, and recommended
                        improvements to tools and workflow processes.
                    </li>
                    <li>Effectively managed high-priority tasks, particularly urgent matters involving high-revenue
                        clients, ensuring timely resolution and client satisfaction.
                    </li>
                    <li>Collaborated with cross-functional teams to develop and implement strategies for intellectual
                        property protection.
                    </li>
                    <li>Maintained up-to-date knowledge of intellectual property laws and regulations to ensure
                        compliance and informed decision-making.
                    </li>
                </ul>
            </div>

            <div className="experience-block">
                <div className="title-company">
                    <h2 className="job-title">Integrity Specialist</h2>
                    <h3 className="company-name">BCforward</h3>
                </div>
                <p className="experience-details">Oct 2017 - Sep 2020 · 3 yrs | Austin, Texas, United States</p>
                <ul>
                    <li>Proficiently handled intellectual property issues, meticulously reviewing infringement reports
                        to identify and address potential violations.
                    </li>
                    <li>Provided valuable input on emerging industry trends, potential escalations, and recommended
                        improvements to tools and workflow processes.
                    </li>
                    <li>Effectively managed high-priority tasks, particularly urgent matters involving high-revenue
                        clients, ensuring timely resolution and client satisfaction.
                    </li>
                    <li>Collaborated with cross-functional teams to develop and implement strategies for intellectual
                        property protection.
                    </li>
                    <li>Maintained up-to-date knowledge of intellectual property laws and regulations to ensure
                        compliance and informed decision-making.
                    </li>
                </ul>
            </div>

            <div className="experience-block">
                <div className="title-company">
                    <h2 className="job-title">Shift Supervisor</h2>
                    <h3 className="company-name">Starbucks</h3>
                </div>
                <p className="experience-details">Apr 2014 - Sep 2017 · 5 yrs 6 mos | Austin, Texas, United States</p>
                <ul>
                    <li>Assumed a leadership role in overseeing store operations in the absence of the store manager,
                        ensuring the seamless execution of daily activities.
                    </li>
                    <li>Maintained strict adherence to operational protocols, focusing on cash handling procedures,
                        safety protocols, and security measures to guarantee a secure and compliant environment.
                    </li>
                    <li>Actively participated in the onboarding and training of new team members, contributing to the
                        development of approximately 15 partners annually.
                    </li>
                    <li>Provided hands-on guidance and support to new team members, fostering their growth within the
                        company and helping them integrate effectively into the team.
                    </li>
                    <li>Demonstrated exceptional organizational skills and a keen eye for detail, ensuring a
                        consistently high level of service and customer satisfaction.
                    </li>
                </ul>
            </div>
        </div>
        </>
    );
}

export default Experience;
